import { IUserReportsServerModel, IPackInfo, IReportRow, IResources } from '../Types';
import { convertExpiryDate } from './Util';

export class ReportsRequestService {
    static parsePackInfo = (data: IUserReportsServerModel): IPackInfo[] => {
        let packInfo = [];
        let resources = window.resources;
        const packs = data.Response && data.Response["Packs"];
        if (packs) {
            packInfo = packs.length
                ? packs.map((pack: any) => {
                    var packInfo: IPackInfo = {
                        serialNumber: pack["Pack"] && pack["Pack"]["SerialNumber"],
                        productCode: pack["Pack"] && pack["Pack"]["ProductCode"],
                        expiryDate: pack["Pack"] && convertExpiryDate(pack["Pack"]["ExpiryDate"]),
                        batchId: pack["Pack"] && pack["Pack"]["BatchId"],
                        uprc: pack["Result"] && pack["Result"].Uprc,
                        status: (pack.Result.OperationCode).toString().startsWith("11") || (pack.Result.OperationCode).toString() === "NMVS_SUCCESS" ? resources.Success : resources.Error,
                        packState: pack["Result"] && pack["Result"].State,
                        warning: pack["Result"] && pack["Result"].Warning,
                        information: pack["Result"] && pack["Result"].Information,
                        isQueuedItem: !data.Response,
                        ragClass: pack.Result.PackActionResult.RagClass,
                        ragIcon: pack.Result.PackActionResult.RagIcon,
                        productName: pack.Result.ProductName,
                        // We have to cater for both single pack response and multiple pack response
                        AmsLink:  pack.Result.AmsLink ?? data.Response.AmsLink ,
                        AlertCode: pack.Result.AlertCode ?? data.Response.AlertCode,
                        Nhrn:  pack.Result.Nhrn ?? data.Response.Nhrn,
                        OperationCode: pack.Result.OperationCode ?? data.Response.OperationCode  
                    }

                    return packInfo;
                })
                : [];
        } else {
            const packState = data.Response && data.Response.State ? data.Response.State : resources.Unknown;
            const uprc = data.Response && data.Response.AlertId;
            let status = resources.Processing;
            if (data.Response) {
                if (!data.Response.OperationCode) {
                    status = resources.Error;
                }
                else {
                    status = data.Response.OperationCode.startsWith("11") || data.Response.OperationCode.toString() === "NMVS_SUCCESS" ? resources.Success : resources.Error;
                }
            }
            packInfo = data.Packs && data.Packs.length
                ? data.Packs.map((el) => {
                    return {
                        batchId: el["BatchId"] ? el["BatchId"] : resources.Unknown,
                        expiryDate: el["ExpiryDate"] ? convertExpiryDate(el["ExpiryDate"]) : resources.Unknown,
                        productCode: el["ProductCode"] ? el["ProductCode"] : resources.Unknown,
                        serialNumber: el["SerialNumber"] ? el["SerialNumber"] : resources.Unknown,
                        packState: packState,
                        status: status,
                        uprc: uprc,
                        warning: data.Response && data.Response.Warning,
                        information: data.Response && data.Response.Information,
                        isQueuedItem: !data.Response,
                        ragClass: data.Response && data.Response.ragClass,
                        ragIcon: data.Response && data.Response.ragIcon,
                        AmsLink: (data.Response && data.Response.AmsLink) ?? el.AmsLink,
                        AlertCode: (data.Response && data.Response.AlertCode) ?? el.AlertCode,
                        Nhrn: (data.Response && data.Response.Nhrn) ?? el.Nhrn,
                        OperationCode: (data.Response && data.Response.OperationCode) ?? el.OperationCode,
                    } as IPackInfo;
                })
                : [];
        }
        return packInfo;
    };

    static parseServerData = (data: IUserReportsServerModel[]): IReportRow[] => {
        return data.map((el) => {
            const resultObject = {} as IReportRow;
            let userInfo, action;
            try {
                action = el.Request ? JSON.parse(el.Request.Body) : null;
            } catch (e) {
                console.error(e);
                action = null;
            }
            try {
                userInfo = JSON.parse(el.UserId);
            } catch (err) {
                console.error(err);
                userInfo = null;
            }
            resultObject.additionalInfo = {
                action: (action && action.State) || el.RequestType,
                submitTime: el.SubmissionTime ? new Date(el.SubmissionTime) : undefined,
                responseTime: el.Response ? new Date(el.Date) : undefined,
                productName: el.Response ? el.Response.ProductName : undefined
            };
            resultObject.additionalInfoIsVisible = false;
            resultObject.id = el.Id;
            resultObject.userInfo = userInfo;
            resultObject.packs = ReportsRequestService.parsePackInfo(el);
            resultObject.isSinglePackResult = el.EntryCategory.startsWith("Single");
            return resultObject;
        });
    };
}